export function Panel({ title, subtitle, actions, children, testid, noPad }) {
  return (
    <section data-testid={testid} className="card-surface rounded-xl">
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 border-b border-fundio-border px-5 py-4">
          <div>
            {title && <h2 className="font-display text-base font-semibold text-fundio-ink">{title}</h2>}
            {subtitle && <p className="mt-0.5 text-xs text-fundio-muted">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={noPad ? "" : "p-2 sm:p-3"}>{children}</div>
    </section>
  );
}
